import { TRANSLATION, DARK_MODE } from "./actions";

const initialState = {
  translation: false,
  darkMode: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case TRANSLATION:
      const boolean = state.translation ? false : true;
      return {
        ...state,
        translation: boolean,
      };
    case DARK_MODE:
      return {
        ...state,
        darkMode: !state.darkMode,
      };
    default: {
      return state;
    }
  }
}
